import { Button, Typography } from '@breetometer/components';
import { FiatIcon, InfoIcon } from 'BreetAssets';
import { Loader, Tooltip, TooltipContent, TransactionDetails } from 'BreetComponents';
import { alwaysRefetchApiQueryOptions } from 'BreetHelpers';
import { useGetUserPreferenceQuery } from 'BreetRedux';

import type { ITransactionDetails } from '../DialogWithdrawRequest.helpers';

const TransactionDetailsSection = ({
	withdrawFunds,
	content,
	balance,
	withdrawalFee,
	narration,
	code,
	totalDeducted,
	isInsufficientFunds,
}: ITransactionDetails) => {
	const { isLoading: userPreferenceLoading } = useGetUserPreferenceQuery(undefined, alwaysRefetchApiQueryOptions);

	if (userPreferenceLoading) return <Loader />;

	return (
		<div className='transaction-details'>
			<TransactionDetails.Content>
				{content.map((row) => (
					<TransactionDetails.Row key={row.label}>
						<TransactionDetails.RowLeft label={row.label} />

						<TransactionDetails.RowRight>
							{!!row.value && (
								<Typography className='transaction-details_content_row_value color-neutral-50'>{row.value}</Typography>
							)}
							{!!row.bankDetails && (
								<>
									<Typography className='transaction-details_content_row_accountname color-neutral-50'>
										{row.bankDetails.accountNumber}
									</Typography>
									<Typography
										as='span'
										className='transaction-details_content_row_accountdetails color-primary-50'
									>
										{row.bankDetails.bankName}
									</Typography>
									<Typography
										as='span'
										className='transaction-details_content_row_accountdetails color-primary-50'
									>
										{row.bankDetails.accountName}
									</Typography>
								</>
							)}
						</TransactionDetails.RowRight>
					</TransactionDetails.Row>
				))}

				{code === 'NGN' && (
					<TransactionDetails.Row>
						<div className='content-row-left content-row-left-narration'>
							<Typography className='transaction-details_content_row_label color-primary-50'>Withdrawal Fees</Typography>
							<Tooltip tipElement={<TooltipContent content='This fee covers stamp duty and charges paid to the bank.' />}>
								<InfoIcon className='info-icon svg-light' />
							</Tooltip>
						</div>
						<TransactionDetails.RowRight value={withdrawalFee} />
					</TransactionDetails.Row>
				)}

				{code === 'NGN' && (
					<TransactionDetails.Row
						label='Total Debit'
						value={totalDeducted}
					/>
				)}

				{narration && (
					<TransactionDetails.Row
						label='Narration'
						value={narration}
					/>
				)}
			</TransactionDetails.Content>

			<div className='transaction-details_balance bg-primary-400 border-dark-navy'>
				<FiatIcon
					currencyCode={code}
					variant='round'
				/>
				&nbsp;
				<Typography className='color-neutral-50'>
					Balance - <span>{balance}</span>
				</Typography>
			</div>

			{isInsufficientFunds && (
				<div className='transaction-details_insufficient-funds bg-dark-maroon'>
					<Typography className='color-error-100'>
						Insufficient Balance! Receive more crypto to complete your withdrawal.
					</Typography>
				</div>
			)}

			<Button
				label='Withdraw Funds'
				onClick={withdrawFunds}
				className='right-sheet_cta_fullwidth'
				type='button'
				disabled={isInsufficientFunds}
			/>
		</div>
	);
};

export default TransactionDetailsSection;
